module.exports = __webpack_public_path__ + "static/img/far3.16d17485.png";